import React, { useState, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./NewDocumentUpload.css";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function NewDocumentUpload() {
  const [file, setFile] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);

  const { t } = useTranslation();

  const navigate = useNavigate();

  let { pid } = useParams();

  const { state } = useContext(AuthContext);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  async function getPresignedUrl(file) {
    try {
      const fileName = file.name;
      const contentType = file.type;

      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/upload/document/presignedUrl`,
        data: {
          filename: fileName,
          contentType: contentType,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  const handleSubmit = async (e) => {
    setIsDisabled(true);
    try {
      const response = await getPresignedUrl(file);

      let presignedUrl = response.url;
      let key = response.key;

      await axios.put(presignedUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/people/upload/document/${pid}`,
        data: {
          key: key,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          "Content-Type": "application/json",
        },
      });

      toast(t("Personas.Persona.Documentos.MensajeToast"));
      setTimeout(() => {
        navigate(`/people/overview/${pid}`, {
          state: { tabKey: "documentos" },
        });
      }, 2000);

      /* const formData = new FormData();
    formData.append("file", file);
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/people/upload/document/${pid}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${state.token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      toast(t("Personas.Persona.Documentos.MensajeToast"));
      setTimeout(() => {
        navigate(`/people/overview/${pid}`, {
          state: { tabKey: "documentos" },
        });
      }, 2000); */
      setIsDisabled(false);
    } catch (error) {
      console.log(error.response.data);
    }
  };

  return (
    <Col className="mt-3 new-document-upload">
      <ToastContainer />
      <Form.Group className="mb-3">
        <Form.Label>
          {t("Personas.Persona.Documentos.SeleccionarArchivo")}
        </Form.Label>
        <Form.Control
          type="file"
          name="file"
          onChange={(e) => handleFileChange(e)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Button
          variant="primary"
          onClick={() => handleSubmit()}
          disabled={isDisabled}
        >
          {t("Personas.Persona.Documentos.ConfirmarSubir")}
        </Button>
        <Button
          variant="secondary"
          onClick={() => navigate(`/people/overview/${pid}`)}
        >
          {t("Personas.Persona.Documentos.Cancelar")}
        </Button>
      </Form.Group>
    </Col>
  );
}

export default NewDocumentUpload;
